import React, { ComponentProps } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { HeroRoot, ImageWrapper, BadgeContainer, HeroContent } from './Hero.styles'
import Image from 'next/image'

import hero from '../../../../../public/assets/wwfr-hero.png'
import badge from '../../../../../public/assets/badge-3-red.svg'
import { Link } from '../../../../components/Link'
import { Button } from '../../../../components/Button'

type HeroOwnProps = ComponentProps<typeof HeroRoot>
export type HeroProps = HeroOwnProps & {}

export const Hero = (_props: HeroProps) => {
  const { t } = useTranslation()

  return (
    <HeroRoot>
      <Stack
        direction={{ '@initial': 'column', '@bp2': 'row' }}
        gap={{ '@initial': '5', '@bp2': '0' }}
      >
        <HeroContent>
          <Stack
            direction="column"
            alignItems={{ '@initial': undefined, '@bp2': 'flex-start' }}
            justifyContent="center"
            gap={{ '@initial': '2', '@bp2': '3' }}
          >
            <Text
              size={{ '@initial': 'h3', '@bp2': 'h1' }}
              as="h1"
              weight="bold"
              color="accent-black"
              align={{ '@initial': 'center', '@bp2': 'left' }}
            >
              {t('why-we-feed-raw:page-title')}
            </Text>
            <Stack direction="column" gap={{ '@initial': '0', '@bp2': '1' }}>
              <Text
                size="headline"
                as="h2"
                weight="bold"
                color="accent-black"
                align={{ '@initial': 'center', '@bp2': 'left' }}
              >
                {t('why-we-feed-raw:hero.description-1')}
              </Text>
              <Text
                size="headline"
                as="h2"
                weight="bold"
                color="accent-black"
                align={{ '@initial': 'center', '@bp2': 'left' }}
              >
                {t('why-we-feed-raw:hero.description-2')}
              </Text>
            </Stack>
            <Link href="/meal-plan" passHref>
              <Button as="a" className="cta">
                {t('why-we-feed-raw:cta-1')}
              </Button>
            </Link>
          </Stack>
        </HeroContent>
        <ImageWrapper>
          <Image src={hero} alt="" />
          <BadgeContainer>
            <Image src={badge} alt="" layout="fill" />
          </BadgeContainer>
        </ImageWrapper>
      </Stack>
    </HeroRoot>
  )
}

Hero.displayName = 'Hero'
